import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetAllTagResponse } from '../../responses/produto/get-all-tag.response';
import { GetTagResponse } from '../../responses/produto/get-tag.response';
import { TagRequest } from '../../requests/produto/tag.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class TagService extends CommonService {
    constructor(
        private httpClient: HttpClient
    ) {
        super();
    }

    private readonly apiUrl = `${environment.urlApiProduto}tag`;

    /**
     * Obtém a lista de Tags.
     * Corresponde a: [HttpGet]
     */
    public getAll(nome: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetAllTagResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (nome) {
            params = params.set('nome', nome);
        }

        return this.httpClient
            .get<GetAllTagResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclui uma tag.
     * Corresponde a: [HttpDelete]
     * @param idTag O ID da tag a ser excluída.
     */
    public delete(idTag: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idTag}`;

        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclui múltiplas tags.
     * Corresponde a: [HttpPost/bulk-delete]
     * @param idsTag Lista de IDs das tags a serem excluídas.
     */
    public deleteBulk(idsTag: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;

        return this.httpClient
            .post<ReturnStruct>(url, { idsTag }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Obtém uma tag por ID.
     * Corresponde a: [HttpGet/:id]
     * @param idTag O ID da tag.
     */
    public getById(idTag: number): Observable<GetTagResponse> {
        const url = `${this.apiUrl}/${idTag}`;

        return this.httpClient
            .get<GetTagResponse>(url, { ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Cria uma nova tag.
     * Corresponde a: [HttpPost]
     * @param request Os dados da tag a ser criada.
     */
    public create(request: TagRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Atualiza uma tag existente.
     * Corresponde a: [HttpPut/:id]
     * @param idTag O ID da tag a ser atualizada.
     * @param request Os dados atualizados da tag.
     */
    public update(idTag: number, request: TagRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idTag}`;

        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
